import { StateCreator } from "zustand"
import { imprimirCode, imprimirHTML } from "../pages/RecebedorDePedidos/qzConfig"
import { alertStart } from "../routes"
import { RegistrarLogErro } from "../services/clientefiel"
import { StoreType } from "./AppStore"

const qz = require("qz-tray")

export type ImpressaoStoreType = {
    setState: (state: Partial<ImpressaoStoreType>) => void

    impressorasQZ: string[]
    buscarImpressoras: () => Promise<string[]>
    tipoPainelImpressao: () => "plugin" | "software" | "navegador"
    mandarImprimir: (configs: any) => Promise<void>
    imprimirQz: (configuracao: any) => Promise<void>
    impressao: (configuracoes: any) => void

    pedidosImpressos: Map<number, boolean>
    imprimiuRecentemente: (idPedido: number) => boolean
}

const createImpressaoStore: StateCreator<StoreType, [], [], ImpressaoStoreType> = (set, get) => ({
    setState: state => set(state),
    impressorasQZ: [],
    buscarImpressoras: async () => {
        try {
            if (qz.websocket.isActive()) {
                const printers = (await qz.printers.find()) as any[]

                set({ impressorasQZ: printers ?? [] })

                return printers
            }

            return qz.websocket.connect().then(async () => {
                const printers = (await qz.printers.find()) as any[]

                set({ impressorasQZ: printers ?? [] })

                return printers
            })
        } catch (error) {
            console.error(error)
            return []
        }
    },
    tipoPainelImpressao: () => {
        try {
            let printers: string[] = get().impressorasQZ.length > 0 ? get().impressorasQZ : []

            // TODO: Sem await pode causar erro
            if (!printers.length)
                get()
                    .buscarImpressoras()
                    .then(p => (printers = p))

            const tipo = printers
                ? printers.length > 0
                    ? "plugin" //qz
                    : window.navigator.userAgent.includes("Electron")
                    ? "software" //exe
                    : "navegador" //padrao do navegador
                : "navegador"

            return tipo
        } catch (error) {
            console.error(error)
            return "navegador"
        }
    },
    mandarImprimir: async configs => {
        const {
            pedido = {},
            texto = "",
            qtd = 1,
            QZObrigatorio = false,
            numeroDaImpressora = 0,
            isResumo = false,
        } = configs

        const configuracoes = get().configuracoes

        console.log("mandar imprimir", configs)
        if (configuracoes!.user!.parametros.assinaturaLimitada === true) {
            alertStart(
                "Não foi impresso, porque sua assinatura está limitada por inadimplência.",
                "error"
            )
            console.error(
                "Não foi impresso, porque sua assinatura está limitada por inadimplência."
            )
            return
        }

        try {
            switch (get().tipoPainelImpressao()) {
                case "navegador":
                    if (!QZObrigatorio) {
                        document.getElementById("rootPrint")!.innerHTML = texto.replace(
                            /(?:\r\n|\r|\n)/g,
                            "<br>"
                        )
                        window.setTimeout(function () {
                            if (configuracoes!.user!.parametros.agruparViasImpressao) {
                                window.print()
                            } else {
                                for (var j = 0; j < qtd; j++) {
                                    window.print()
                                }
                            }
                        }, 200)
                    }
                    break

                case "plugin":
                    if (numeroDaImpressora === 0) {
                        const impressorasConfiguradas = configuracoes!.printer
                            .impressoras as string[]

                        if (!impressorasConfiguradas.length)
                            throw new Error("Sua lista de impressoras está vazia")

                        let primeiroTextoAlternadoNaoImpresso = 0
                        impressorasConfiguradas.forEach(async (impressora, i) => {
                            configs.impressora = impressora

                            if (!isResumo && configuracoes!.user!.parametros.impressaoAlternada) {
                                const textoImpressaoAlternada = pedido["texto" + (i + 1)]

                                // Se for impressão alternada, imprime somente na impressora que houver produtos referentes a ela
                                if (!textoImpressaoAlternada) {
                                    console.warn(
                                        `Impressão Alternada para impressora Nº${
                                            i + 1
                                        } falhou ao imprimir o pedido ${
                                            pedido.id
                                        }, pois não há o texto referente`
                                    )
                                    return
                                }

                                primeiroTextoAlternadoNaoImpresso = i + 1
                                configs.texto = textoImpressaoAlternada
                            }

                            await get().imprimirQz(configs)
                        })

                        // Impressão da comanda completa para impressão alternada
                        if (
                            configuracoes!.user!.parametros.impressaoAlternada &&
                            configuracoes!.printer.imprimirComandaCompleta
                        ) {
                            configs.impressora = configuracoes!.printer.impressoraComandaCompleta
                            configs.texto = pedido.texto

                            await get().imprimirQz(configs)
                        }

                        // Checa se hovue textos não impressos por falta de impressora
                        if (pedido["texto" + (primeiroTextoAlternadoNaoImpresso + 1)]) {
                            console.error(
                                `Não foi possível completar a Impressão Alternada, pois não há impressora Nº${
                                    primeiroTextoAlternadoNaoImpresso + 1
                                }`
                            )
                            // alertStart(
                            //     `Não foi possível completar a Impressão Alternada, pois não há impressora Nº${primeiroTextoAlternadoNaoImpresso + 1
                            //     }`,
                            //     "warning"
                            // )

                            let maiorTextoImpressao = 0
                            for (let i = primeiroTextoAlternadoNaoImpresso + 1; true; i++) {
                                if (pedido["texto" + i]) maiorTextoImpressao = i
                                else break
                            }

                            for (
                                let i = primeiroTextoAlternadoNaoImpresso + 1;
                                i <= maiorTextoImpressao;
                                i++
                            ) {
                                get().mandarImprimir({
                                    texto: pedido["texto" + i],
                                    numeroDaImpressora: 1,
                                })
                            }
                        }
                    } else {
                        const impressorasConfiguradas = configuracoes!.printer
                            .impressoras as string[]
                        const impressora = impressorasConfiguradas[numeroDaImpressora - 1]

                        if (!impressora)
                            throw new Error(`${numeroDaImpressora}ª Impressora não selecionada`)

                        configs.impressora = impressora

                        if (configuracoes!.user!.parametros.impressaoAlternada) {
                            const textoImpressaoAlternada = pedido["texto" + numeroDaImpressora]

                            if (textoImpressaoAlternada) configs.texto = textoImpressaoAlternada
                        }

                        await get().imprimirQz(configs)
                    }
                    break

                case "software":
                    console.log(`01[${texto}]{${qtd}}`)
                    break

                default:
                    break
            }
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "mandarImprimir", configs)
        }
    },
    imprimirQz: async (configuracao: any) => {
        let { impressora = "" } = configuracao

        try {
            if (qz.websocket.isActive()) {
                if (!impressora || impressora == "vazio") {
                    impressora = await qz.printers.getDefault()
                }

                configuracao.impressora = impressora

                return get().impressao(configuracao)
            }

            qz.websocket
                .connect()
                .then(() => {
                    if (!impressora) impressora = qz.printers.getDefault()

                    return impressora
                })
                .then((printer: string) => {
                    configuracao.impressora = printer

                    get().impressao(configuracao)
                })
                .catch((err: any) => {
                    console.error("erro", err)
                    RegistrarLogErro(err, "imprimirQz", configuracao)
                })
        } catch (error) {
            RegistrarLogErro(error, "imprimirQz", configuracao)
        }
    },
    impressao: configs => {
        try {
            configs.qz = qz
            configs.printer = get().configuracoes!.printer

            if (get().configuracoes!.printer.imprimirLogo)
                configs.logo = get().configuracoes!.user!.parametros.estabelecimento?.urlLogo

            if (get().configuracoes!.printer.tipoImpressao == "code") imprimirCode(configs)
            else imprimirHTML(configs)

            if (configs.pedido?.id) get().pedidosImpressos.set(configs.pedido.id, true)
        } catch (error) {
            console.error(error)
            alertStart((error as any).message, "error")
            RegistrarLogErro(error, "impressao", configs)
        }
    },
    pedidosImpressos: new Map(),
    imprimiuRecentemente: idPedido => get().pedidosImpressos.get(idPedido) ?? false,
})

export default createImpressaoStore
